import { MiscService } from "../Misc";

const language = {
  en: require("../../../language/en.json"),
  hi: require("../../../language/hi.json"),
};

export class LocaleService {
  static getLocale = (): string => {
    return localStorage.getItem("locale") || "en";
  };
  static setLocale = (locale: string) => {
    localStorage.setItem("locale", locale);
  };
  parseLocale = (lng: object, key: string): string => {
    const { isEmpty } = new MiscService();
    if (!isEmpty(lng[key])) {
      return lng[key];
    } else {
      const trnKey = key.substring(0, key.indexOf("."));
      return this.parseLocale(lng[trnKey], key.replace(trnKey + ".", ""));
    }
  };

  translate = (key: string): string => {
    const locale = LocaleService.getLocale();
    return this.parseLocale(language[locale], key) ?? key;
  };
}
